<template lang="html">
  <div>
    In progress...
  </div>
</template>

<script>
export default {
  name: 'example-page'
};
</script>


// WEBPACK FOOTER //
// home.vue?e8fd49b2